//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import placeholderImg from "../pages/page-components/placeholderImg";
import * as shopinfo from "@/api/mall/shopinfo";
export default {
  data: function data() {
    return {
      defaultImage: require("../assets/images/icon/img_pic@2x.png"),
      shopInfo: {}
    };
  },
  components: {
    placeholderImg: placeholderImg
  },
  props: {
    shopId: {
      type: String
    },
    thememobile: {
      type: Object | Array
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;
    shopinfo.getObj(this.shopId).then(function (response) {
      _this.shopInfo = response.data.data;
    });
  },
  methods: {},
  watch: {},
  beforeDestroy: function beforeDestroy() {
    // this.$root.Bus.$off('addHotSpot')
  }
};